import React from 'react';
import storage from 'features/PersistentStorage';
import { LoginMobile, WithClearSafariPageCache } from '@it25syv/25syv-ui';
import loginBanner from './assets/login-banner.jpg';
import { navigateWithRefresh } from 'utils/navigation';

const ANIMATED_BUTTON_WARNING =
    'MobileLogin: you must assign a value for resetAnimatedButtonHandler';

class MobileLogin extends React.Component {
    resetAnimatedButtonHandler = null;

    state = {
        userName: storage.get('userName', null, ''),
        password: '',
    };

    newLoginHandler = (userName, password) => {
        if (userName && password) {
            this.props.onLoginClick(userName, password);
            storage.saveLS({ userName: userName });
        } else {
            console.log('Handle error'); //todo handle error
        }
    };

    resetAnimatedButton() {
        try {
            this.resetAnimatedButtonHandler();
        } catch (error) {
            console.info(ANIMATED_BUTTON_WARNING);
        }
    }

    componentDidUpdate() {
        if (this.props.error) {
            this.resetAnimatedButton();
        }
    }

    render() {
        const { close } = this.props;

        return (
            <LoginMobile
                bgImage={loginBanner}
                showRegisterModal={() => {
                    // It's not recommended to show Sign UP modal after
                    // the login modal, as the app will have 2 instances
                    // and nem id will not work on Sign Up then.
                    // Strongly not recommended to use showModal here.
                    setTimeout(() => {
                        navigateWithRefresh('/opret-konto');
                    }, 500);
                }}
                closeAction={close}
                loginHandler={this.newLoginHandler}
                site={'heste'}
            />
        );
    }
}

export default WithClearSafariPageCache(MobileLogin);
